import { render, staticRenderFns } from "./editPrediction.vue?vue&type=template&id=7498dd84&"
import script from "./editPrediction.vue?vue&type=script&lang=js&"
export * from "./editPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports